/**
 * 再資源化等パターン
 * 処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const search_recycle_disposer = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処分業者リストの取得
     * @param commit
     * @param condition { Object }
     * @param condition.target_id { Number | null } 事業者ID
     * @param condition.target_type { String | null } 事業者種別(Trader::ReportingTrader or FinalDisposalSite)
     * @param condition.location_id { Number|null } 処分事業場ID
     * @param condition.query { String|null } キーワード
     * @param condition.own_disposer { Boolean } 自社処分のみ
     * @param condition.without_invisible { Boolean } 非表示を除く
     * @param condition.page { Number } ページ番号
     * @return {Promise<Object>}
     */
    index ({ commit }, { condition }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposers`, { params: condition }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_recycle_disposer
